import axios from 'axios'
  import config from './config'
  export default {
  
    getProcedure(request = {}) {
      const ldata = localStorage.getItem('users')
      if ( ldata == null ) return []
      const data = JSON.parse( ldata )
      const token = data.token
     
      return axios.get(config.serverURI + '/procedure', {
          dataType: 'json',
          params:request,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        })
        .then((response) => Promise.resolve(response))
        .catch((error) => Promise.reject(error))
    },
    getProcedureDetails (Id = '') {
      const ldata = localStorage.getItem('users')
      if ( ldata == null ) return []
      const data = JSON.parse( ldata )
      const token = data.token
     
      return axios.get(config.serverURI + '/procedure/' + Id, {
          dataType: 'json',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        })
        .then((response) => Promise.resolve(response))
        .catch((error) => Promise.reject(error))
    },
    addProcedure (request = {}) {
      const ldata = localStorage.getItem('users')
      if ( ldata == null ) return []
      const data = JSON.parse( ldata )
      const token = data.token
     var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
      }
      return axios.post(config.serverURI + '/procedure', request , {"headers" : headers} )
        .then((response) => Promise.resolve(response))
        .catch((error) => Promise.reject(error))
    },
    updateProcedure (request = {}) {
      const ldata = localStorage.getItem('users')
      if ( ldata == null ) return []
      const data = JSON.parse( ldata )
      const token = data.token
      const id = request._id
      delete request._id
      var headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
      return axios.patch(config.serverURI + '/procedure/' + id, request , {"headers" : headers} )
        .then((response) => Promise.resolve(response))
        .catch((error) => Promise.reject(error))
    }
  }
  


// WEBPACK FOOTER //
// ./src/vuex/api/services/Procedure.js